<ng-template #acceptTermsText>Trebuie să accepți termenii, condițiile și politica GDPR pentru a putea trimite comanda.</ng-template>
<ng-template #deliveryFormError>Aveți o problemă la datele de livrare.</ng-template>
<ng-template #billingFormError>Aveți o problemă la datele de facturare.</ng-template>

<div class="button-group-container">
  <mat-button-toggle-group [(ngModel)]="customerType" name="fontStyle" aria-label="Font Style"
                           (click)="changeCustomerType()">
    <mat-button-toggle class="toggle-btn" [ngClass]="{'toggle-btn-active': customerType === 'fizica'}" value="fizica">
      Persoană fizică
    </mat-button-toggle>
    <mat-button-toggle class="toggle-btn" [ngClass]="{'toggle-btn-active': customerType === 'juridica'}" value="juridica">
      Persoană juridică
    </mat-button-toggle>
  </mat-button-toggle-group>
  <mat-card appearance="outlined" *ngIf="customerType === 'fizica'" class="card-radius card-container">
    <mat-card-header>
      <mat-card-title>
        Date de facturare
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="individualForm" name="contact">
        <div class="company">
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Prenume</mat-label>
            <input matInput placeholder="Prenume" type="text" formControlName="firstName" name="firstName" [required]="true" autocomplete="given-name">
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Nume</mat-label>
            <input matInput placeholder="Nume" type="text" formControlName="lastName" name="lastName" [required]="true" autocomplete="family-name">
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>CNP</mat-label>
            <input matInput  matTooltip="In conformitate cu OUG 69/2024 CNP-ul devine obligatoriu pentru facturare" placeholder="CNP" type="number" formControlName="cnp" name="cnp" [required]="true" autocomplete="cnp">
            <span class="validation-error">{{individualForm.controls.cnp.touched && individualForm.controls.cnp.errors ? 'CNP-ul nu este valid' : ''}}</span>
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Număr de telefon</mat-label>
            <input matInput placeholder="Număr de telefon" type="text" formControlName="phoneNumber" name="phoneNumber"
                   (change)="trimWhitespaces(individualForm, 'phoneNumber')" [required]="true" autocomplete="tel">
            <span class="validation-error">{{individualForm.controls.phoneNumber.touched && individualForm.controls.phoneNumber.errors ? 'Numarul de telefon nu este valid' : ''}}</span>
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Email</mat-label>
            <input matInput placeholder="Email" type="text" formControlName="email" name="email"
                   (change)="trimWhitespaces(individualForm, 'email')" [required]="true" autocomplete="email">
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Județ</mat-label>
            <input type="text" matInput placeholder="Județ" formControlName="county" name="county"
                   autocomplete="doNotAutoComplete"
                   [matAutocomplete]="invidualCountyAutocomplete" required (input)="filterCounties($event)"
                   (focus)="filterCounties($event)">
            <mat-autocomplete requireSelection #invidualCountyAutocomplete="matAutocomplete">
              <mat-option *ngFor="let county of filteredCounties" [value]="county.value">
                {{ county.label }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Localitate</mat-label>
            <input matInput placeholder="Localitate" type="text" formControlName="city" name="city" [required]="true" autocomplete="billing address-level2">
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always" style="width: 100%">
            <mat-label>Adresa de facturare</mat-label>
            <input matInput placeholder="Adresa" type="text" formControlName="address" name="address" [required]="true" autocomplete="billing street-address" >
          </mat-form-field>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined" *ngIf="customerType === 'juridica'" class="card-radius card-container">
    <mat-card-header>
      <mat-card-title>
        Date companie
      </mat-card-title>
    </mat-card-header>
    <form class="form-style" [formGroup]="companyForm" name="companyContact">
      <mat-card-content [style.padding-top.px]="0">
        <div class="company">
          <mat-form-field appearance="fill" floatLabel="always" style="width: 100%">
            <mat-label>Nume companie</mat-label>
            <input matInput placeholder="Nume companie" type="text" formControlName="name" name="companyName" required>
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Cod unic de înregistrare</mat-label>
            <input matInput placeholder="Cod unic" type="text" formControlName="registrationId" name="registrationId"
                   required>
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Număr de înregistrare în Registrul Comerțului</mat-label>
            <input matInput placeholder="Număr de înregistrare" type="text" formControlName="registrationNumber"
                   name="registrationNumber" required>
          </mat-form-field>
        </div>
        <div class="company">
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Nr. de telefon</mat-label>
            <input matInput placeholder="Nr. telefon" type="text" formControlName="phoneNumber" name="phoneNumber"
                   (change)="trimWhitespaces(deliveryFrom, 'phoneNumber')" required>
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Email</mat-label>
            <input matInput placeholder="Email" type="email" formControlName="email" name="email"
                   (change)="trimWhitespaces(companyForm, 'email')" required>
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Județ</mat-label>
            <input type="text" matInput placeholder="Județ" formControlName="county" name="county"
                   autocomplete="doNotAutoComplete"
                   [matAutocomplete]="companyCountyAutocomplete" required (input)="filterCounties($event)"
                   (focus)="filterCounties($event)">
            <mat-autocomplete requireSelection #companyCountyAutocomplete="matAutocomplete">
              <mat-option *ngFor="let county of filteredCounties" [value]="county.value">
                {{ county.label }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Localitate</mat-label>
            <input matInput placeholder="Localitate" type="text" formControlName="city" name="city" required>
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always" style="width: 100%">
            <mat-label>Adresă</mat-label>
            <input matInput placeholder="Adresă de facturare" type="text" formControlName="address" name="address"
                   required>
          </mat-form-field>
        </div>
      </mat-card-content>
      <mat-card-header [style.padding-top.px]="0">
        <mat-card-title>
          Date reprezentant firmă
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="company">
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Prenume</mat-label>
            <input matInput placeholder="Prenume" type="text" formControlName="representativeLastName"
                   name="representativeFirstName">
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Nume</mat-label>
            <input matInput placeholder="Nume" type="text" formControlName="representativeFirstName"
                   name="representativeLastName">
          </mat-form-field>
        </div>
      </mat-card-content>
    </form>
  </mat-card>

  <mat-card appearance="outlined" class="card-radius card-container">
    <mat-card-header>
      <mat-card-title>
        Date de livrare
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="additional-info" style="margin-bottom: 10px;">
        Livrăm în toată țara.
      </div>
      <form class="form-style" [formGroup]="deliveryFrom" name="deliveryContact">
        <mat-checkbox formControlName="copyFromContact" (change)="copyFromContact($event)" color="primary">
          La fel ca și la datele de facturare
        </mat-checkbox>
        <div class="company">
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Județ</mat-label>
            <input type="text" matInput placeholder="Județ" formControlName="county" name="county"
                   autocomplete="doNotAutoComplete"
                   [matAutocomplete]="deliveryCountyAutocomplete" required (input)="filterCounties($event)"
                   (focus)="filterCounties($event)">
            <mat-autocomplete requireSelection #deliveryCountyAutocomplete="matAutocomplete">
              <mat-option *ngFor="let county of filteredCounties" [value]="county.value">
                {{ county.label }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Localitate</mat-label>
            <input matInput placeholder="Localitate" type="text" formControlName="city" name="city" [required]="true" autocomplete="shipping address-level2">
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Adresă de livrare</mat-label>
            <input matInput placeholder="Adresă de livrare" type="text" formControlName="address" name="deliveryAddress" autocomplete="shipping street-address"
                   required>
          </mat-form-field>
          <mat-form-field appearance="fill" floatLabel="always">
            <mat-label>Nr. telefon persoană de contact</mat-label>
            <input matInput placeholder="Nr. telefon" type="text" formControlName="phoneNumber"
                   name="deliveryPhoneNumber" autocomplete="tel"
                   (change)="trimWhitespaces(deliveryFrom, 'phoneNumber')" required>
          </mat-form-field>
        </div>
        <div class="deliveryDate" *ngIf="(loggedInUser | async)?.id">
          <mat-form-field appearance="fill" floatLabel="always" (click)="picker.open()">
            <mat-label>Livrare începând cu data de</mat-label>
            <input matInput [matDatepicker]="picker" name="toDeliverAt" formControlName="toDeliverAt"
                   [min]="toDeliverAtMinDate()" readonly>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker [disabled]="false"></mat-datepicker>
          </mat-form-field>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined" class="card-radius card-container" id="payment-options">
    <mat-card-header>
      <mat-card-title>
        Opțiuni de plată
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="orderForm" class="form-style">
        <mat-radio-group formControlName="paymentType" aria-label="Select an option">
          <mat-accordion>
            <mat-expansion-panel hideToggle disabled [expanded]="paymentType === paymentTypes.Card" (opened)="changePaymentType(paymentTypes.Card)">
              <mat-expansion-panel-header (click)="changePaymentType(paymentTypes.Card)">
                <mat-panel-title>
                  <mat-radio-button color="primary" value="card">
                    <span>Card</span>
                  </mat-radio-button>
                </mat-panel-title>
                <mat-panel-description>
                  <span class="hide-mobile">
                  Plata cu orice card de debit sau credit
                    </span>
                  <div class="option-icons">
                    <img ngSrc="assets/card-logos.svg" alt="visa, mastercard, maestro" height="25" width="145">
                  </div>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="additional-info">
                <p>Prin plata cu cardul comanda va fi confirmată imediat si preluată de un operator in cel mai scurt
                  timp posibil.</p>
                <p>Suportăm orice tip de card, inclusiv cardurile de cumpărături.</p>
              </div>
              <contact-payment-amount [offerSubject]="offerSubject" [customerType]="customerType"></contact-payment-amount>
            </mat-expansion-panel>
            <mat-expansion-panel hideToggle disabled [expanded]="paymentType === paymentTypes.PaymentOrder" (opened)="changePaymentType(paymentTypes.PaymentOrder)">
              <mat-expansion-panel-header (click)="changePaymentType(paymentTypes.PaymentOrder)">
                <mat-panel-title>
                  <mat-radio-button color="primary" value="payment_order">
                    <span>Ordin de plată</span>
                  </mat-radio-button>
                </mat-panel-title>
                <mat-panel-description>
                  <span class="hide-mobile">Plata prin transfer bancar</span>
                  <div class="option-icons">
                    <mat-icon>account_balance</mat-icon>
                  </div>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <div class="additional-info">
                <p>După plasarea comenzii, vei primi factura proformă prin email. Cu factura proformă plata se poate
                  efectua la banca la care aveți cont.</p>
                <p>Comanda va fi plasată în momentul în care plata va fi confirmată.</p>
              </div>
              <contact-payment-amount [offerSubject]="offerSubject" [customerType]="customerType"></contact-payment-amount>
            </mat-expansion-panel>
            <mat-expansion-panel hideToggle disabled [expanded]="paymentType === paymentTypes.Tbi" (opened)="changePaymentType(paymentTypes.Tbi)">
              <mat-expansion-panel-header (click)="changePaymentType(paymentTypes.Tbi)">
                <mat-panel-title>
                  <mat-radio-button color="primary" value="tbi">
                    <span>Rate prin TBI Bank</span>
                  </mat-radio-button>
                </mat-panel-title>
                <mat-panel-description>

                  <div class="hide-mobile">
                    <p>Rate prin TBI, veti fi contactat telefonic pentru mai multe detalii</p>
                  </div>
                  <div class="option-icons">
                    <img ngSrc="assets/tbilogo.png" height="20" width="49">
                  </div>
                </mat-panel-description>
              </mat-expansion-panel-header>
              <p>Comanda va fi plasată în momentul în care ratele dvs vor fi aprobate.</p>
            </mat-expansion-panel>
          </mat-accordion>
        </mat-radio-group>
        <div class="notes">
          <mat-form-field [style.width.%]="100" appearance="fill" subscriptSizing="dynamic">
            <mat-label>Observații comandă</mat-label>
            <textarea matInput formControlName="additionalInfo" width="100%"
                      title="Dacă ai nelămuriri sau dorești să ne comunici ceva o poți face aici"></textarea>
          </mat-form-field>
        </div>
        <div class="summary">
          <div class="summary-price">
            <h1 *ngIf="partialPayment">
              Avans: {{getPartialPaymentAmount() | roncurrency}}</h1>
            <h1 *ngIf="!partialPayment">Total: {{offer?.discountedTotal | roncurrency}}</h1>
            <div class="additional-info">
              Termen de livrare estimat: 2-7 zile lucrătoare
            </div>
            <mat-checkbox formControlName="termsConditions" color="primary" [required]="true">
              <span>Accept</span>&nbsp;<a target="_blank" href="https://experttabla.ro/termeni-si-conditii">termenii și
              condițiile</a>
            </mat-checkbox>
            <mat-checkbox formControlName="gdpr" color="primary" [required]="true" id="gdprCheckbox">
              <span>Accept</span>&nbsp;<a target="_blank" href="https://experttabla.ro/gdpr">
              <span>politica GDPR</span>
            </a>
            </mat-checkbox>
            <div *ngIf="!orderForm?.valid" class="accept-terms accept-terms-mobile">
              <ng-container *ngTemplateOutlet="acceptTermsText"></ng-container>
            </div>
            <div *ngIf="!deliveryFrom?.valid" class="accept-terms accept-terms-mobile">
              <ng-container *ngTemplateOutlet="deliveryFormError"></ng-container>
            </div>
            <div *ngIf="!billingFormValid" class="accept-terms accept-terms-mobile">
              <ng-container *ngTemplateOutlet="billingFormError"></ng-container>
            </div>
          </div>
          <div class="summary-button">
            <button class="mb-8 full-width" mat-raised-button type="submit" color="primary"
                    [disabled]="!allFormsAreValid()"
                    (click)="placeOrder()" (submit)="placeOrder()" gaEvent="contact_send_order"
                    gaCategory="buttons_tracking">
              <mat-icon>done</mat-icon>
              {{orderForm.controls.paymentType.value === 'card' ? 'Spre plată' : 'Trimite comanda'}}
            </button>
            <div *ngIf="!orderForm?.valid" class="accept-terms accept-terms-desktop">
              <ng-container *ngTemplateOutlet="acceptTermsText"></ng-container>
            </div>
            <div *ngIf="!deliveryFrom?.valid" class="accept-terms accept-terms-desktop">
              <ng-container *ngTemplateOutlet="deliveryFormError"></ng-container>
            </div>
            <div *ngIf="!billingFormValid" class="accept-terms accept-terms-desktop">
              <ng-container *ngTemplateOutlet="billingFormError"></ng-container>
            </div>
          </div>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
  <div class="button-navigation">
    <button mat-raised-button
            [routerLink]="['/cos']"
            gaEvent="contact_to_cart"
            gaCategory="buttons_tracking"
            class="stepper-button">
      <mat-icon>arrow_backward</mat-icon>
      Înapoi la coș
    </button>
  </div>
</div>
